import { faSignalStream } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import Tooltip from '../../Tooltip/Tooltip';

const WebsiteIcon = () => {
    const [tooltipRef, setTooltipRef] = useState<any>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipHover = (value: boolean) => () => setShowTooltip(value);

    return <>
        <FontAwesomeIcon
            ref={setTooltipRef}
            onMouseEnter={handleTooltipHover(true)}
            onMouseLeave={handleTooltipHover(false)}
            icon={faSignalStream}
            color='#22b58b'
        />
        {
            showTooltip &&
            <Tooltip ref={tooltipRef}>
                Dit veld wordt gebruikt op de website en jobboards
            </Tooltip>
        }
    </>
}

export default WebsiteIcon;